import { render, staticRenderFns } from "./CommunitiesFilter.vue?vue&type=template&id=27976bb0"
import script from "./CommunitiesFilter.vue?vue&type=script&lang=js"
export * from "./CommunitiesFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports